/*
 * @Description: 自然人
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { accountManagement } from '@/api/ajax';
import fields from '../fields';
import search from '../search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

let example = new TableRenderClass({ fields, search });
let part = example.createPart({
  name: '查看',
  search: ['happendTime', 'optionType', 'subAccountName'],
  list: accountManagement.viewOperationLog,
  defaultQuery: { type: 2 },
  fields: ['index', 'logAction', 'createDt', 'userName', 'ip', 'description']
});

export default part;
